import Request from '@/services/util/request-service';
import toast from 'react-hot-toast';
import { QuizGenResponse } from 'quiz-types';

export const QuizGenService = {
  generateQuizData: async (
    quizName: string,
    questionCount: number,
    courseName: string,
    quizDifficulty: string,
    quizDetails: string,
  ): Promise<QuizGenResponse | undefined> => {
    // Format request data
    const data = {
      quizName: quizName,
      questionCount: questionCount,
      courseName: courseName,
      quizDifficulty: quizDifficulty,
      quizDetails: quizDetails,
    };

    // Send data to aurora API
    // Catch any type errors or incomplete body
    try {
      const res = await Request.post('quiz/generate', data, true);
      const body: QuizGenResponse = await res?.json();
      if (res && res.status === 429) {
        const msg =
          (body as any)?.error === 'limit_reached'
            ? `Monthly quiz AI token limit reached for this subdomain.`
            : 'Monthly quiz AI token limit reached.';
        toast.error(msg);
        return undefined;
      }

      // Set quiz questions if successful
      if (!res || !body) {
        // TODO:: send error response to LOGGING API
        throw new Error('Response body is undefined');
      }
      return body;
    } catch (error) {
      console.log(error);
      return undefined;
    }
  },
};
